import { render, staticRenderFns } from "./applyList.vue?vue&type=template&id=24a8674b&"
import script from "./applyList.vue?vue&type=script&lang=ts&"
export * from "./applyList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports